<template>
  <v-col cols="3" class="text-center ml-8" align-self="center">
    <div v-if="!archive || acao === 'DiscarConferencia'">
      <v-card-text>
        <strong>Gravação: </strong>
        <v-icon color="darkRed">mdi-close</v-icon>
      </v-card-text>
    </div>
    <div v-else>
      <v-card-text>
        <v-btn
          outlined
          small
          icon
          class="ma-2"
          :color="color"
          @click.native="playing ? pause() : play()"
          :disabled="!loaded"
        >
          <v-icon v-if="!playing || paused">mdi-play</v-icon>
          <v-icon v-else>mdi-pause</v-icon>
        </v-btn>
        <v-btn
          icon
          outlined
          small
          class="ma-2"
          :color="color"
          @click.native="loaded ? download() : reload()"
          v-if="!loaded"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn
          icon
          outlined
          small
          class="ma-2"
          :color="color"
          @click.native="loaded ? download() : reload()"
          v-if="loaded && downloadable"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-progress-linear
          v-model="percentage"
          height="5"
          class="hover my-0"
          @click.native="setPosition()"
          :disabled="!loaded"
        />
      </v-card-text>
      <audio id="player" ref="player" v-on:ended="ended" v-on:canplay="canPlay" :src="file" />
    </div>
  </v-col>
</template>
<script>
// import RelatorioChamadasHttpService from "../_services/RelatorioChamadasHttpService";
import { hostname } from '@/utils/hostname'
const formatTime = second => new Date(second * 1000).toISOString().substr(11, 8)
export default {
  name: 'player',
  props: {
    acao: {
      type: String,
      default: null,
    },
    file: {
      type: String,
      default: null,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    ended: {
      type: Function,
      default: () => {},
    },
    canPlay: {
      type: Function,
      default: () => {},
    },
    color: {
      type: String,
      default: null,
    },
    downloadable: {
      type: Boolean,
      default: false,
    },
    archive: {
      type: String,
      default: null,
    },
  },
  computed: {
    duration: function() {
      return this.audio ? formatTime(this.totalDuration) : ''
    },
  },
  data() {
    return {
      firstPlay: true,
      isMuted: false,
      loaded: false,
      playing: false,
      paused: false,
      percentage: 0,
      currentTime: '00:00:00',
      audio: undefined,
      totalDuration: 0,
    }
  },
  methods: {
    setPosition() {
      this.audio.currentTime = parseInt((this.audio.duration / 100) * this.percentage)
    },
    play() {
      if (this.playing) return
      this.audio.play().then(() => (this.playing = true))
      this.paused = false
    },
    pause() {
      this.paused = !this.paused
      this.paused ? this.audio.pause() : this.audio.play()
    },
    download() {
      if (this.acao === 'DiscarConferencia') {
        window.open(`https://${hostname()}/backend/asterisk/relatorios/download/conferencia/${this.archive}`)
      } else {
        window.open(`https://${hostname()}/backend/asterisk/gravacao/download/${this.archive}`)
      }
    },
    reload() {
      this.audio.load()
    },
    _handleLoaded: function() {
      if (this.audio.readyState >= 2) {
        if (this.audio.duration === Infinity) {
          // Fix duration for streamed audio source or blob based
          // https://stackoverflow.com/questions/38443084/how-can-i-add-predefined-length-to-audio-recorded-from-mediarecorder-in-chrome/39971175#39971175
          this.audio.currentTime = 1e101
          this.audio.ontimeupdate = () => {
            this.audio.ontimeupdate = () => {}
            this.audio.currentTime = 0
            this.totalDuration = parseInt(this.audio.duration)
            this.loaded = true
          }
        } else {
          this.totalDuration = parseInt(this.audio.duration)
          this.loaded = true
        }
        if (this.autoPlay) this.audio.play()
      } else {
        throw new Error('Failed to load sound file')
      }
    },
    _handlePlayingUI: function() {
      this.percentage = (this.audio.currentTime / this.audio.duration) * 100
      this.currentTime = formatTime(this.audio.currentTime)
      this.playing = true
    },
    _handlePlayPause: function(e) {
      if (e.type === 'play' && this.firstPlay) {
        // in some situations, audio.currentTime is the end one on chrome
        this.audio.currentTime = 0
        if (this.firstPlay) {
          this.firstPlay = false
        }
      }
      if (e.type === 'pause' && this.paused === false && this.playing === false) {
        this.currentTime = '00:00:00'
      }
    },
    _handleEnded() {
      this.paused = this.playing = false
    },
    init: function() {
      this.audio.addEventListener('timeupdate', this._handlePlayingUI)
      this.audio.addEventListener('loadeddata', this._handleLoaded)
      this.audio.addEventListener('pause', this._handlePlayPause)
      this.audio.addEventListener('play', this._handlePlayPause)
      this.audio.addEventListener('ended', this._handleEnded)
    },
  },
  mounted() {
    this.audio = this.$refs.player
    this.init()
  },
  beforeDestroy() {
    this.audio.removeEventListener('timeupdate', this._handlePlayingUI)
    this.audio.removeEventListener('loadeddata', this._handleLoaded)
    this.audio.removeEventListener('pause', this._handlePlayPause)
    this.audio.removeEventListener('play', this._handlePlayPause)
    this.audio.removeEventListener('ended', this._handleEnded)
  },
}
</script>

<style scoped>
.hover:hover {
  cursor: pointer;
}
</style>
